import React from 'react';
import { Route } from 'react-router-dom';

import { RedirectToPublicProposal } from '../redirect-to-public-proposal';

import {
  GENERAL_SIMULATION_PATH,
  GENERAL_DETAILED_ANALYSIS_PATH,
  GENERAL_SIMPLIFIED_PROPOSAL_PATH,
} from '../constants';

export const getProposalRoutes = () => [
  <Route key="proposal" path={GENERAL_SIMULATION_PATH} element={<RedirectToPublicProposal />} />,
  <Route key="detailed-analysis" path={GENERAL_DETAILED_ANALYSIS_PATH} element={<RedirectToPublicProposal />} />,
  <Route key="simplified-proposal" path={GENERAL_SIMPLIFIED_PROPOSAL_PATH} element={<RedirectToPublicProposal />} />,
];
